module.exports = __webpack_public_path__ + "static/img/200009.50a44f51.png";